import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import PlumbingPage from "../pages/plumbing/page";
import ContactPage from "../pages/contact/page";
import LocationPage from "../pages/location/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/plumbing", element: <PlumbingPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/location", element: <LocationPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
